export default __webpack_public_path__ + "static/media/sidebar-bullet-disable.acf98f90.svg";